import {CacheStatus} from "./cache-status";

export class CacheStatusMapper {
  public static map(data: any) {
    const cacheStatus: CacheStatus = new CacheStatus();
    cacheStatus.cacheDate = data.clear_cache_date;
    cacheStatus.cacheEnabled = !!data.page_cache;

    return cacheStatus;
  }
}
